import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'
import unitTaskStatuses from '../../_constants/unitTaskStatuses'

export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
)

class UnitTaskStatusSelectBtns extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      defaultValue: '',
      data: unitTaskStatuses
    }
  }

  // componentWillMount() {
  //   this.getData();
  // }

  // getData() {
  //   provincesService.getAll()
  //     .then((res) => {
  //       // // console.log(res.data)
  //       let data = res.data.map(elm => ({ "label": elm.name, "value": elm.id }))
  //       this.setState({ data: data, loading: false, isSubmitting: false });
  //     })
  // };

  handleChange = e => {
    // // console.log(e);

    this.props.onChange(e)
  }

  render() {
    const { loading, data } = this.state
    const { disabled, defaultValue, exceptions } = this.props

    return (
      <ul className="unit-task-status-btns">
        {data &&
          data.length > 0 &&
          data
            .filter(el => (exceptions ? !exceptions.includes(el.value) : true))
            .map((item, index) => (
              <li key={`unit-task-status-${item.value}`}>
                <a
                  className={defaultValue === item.value ? 'active' : ''}
                  onClick={() => this.handleChange(item.value)}>
                  {item.label}
                </a>
              </li>
            ))}
      </ul>
    )
  }
}
export default UnitTaskStatusSelectBtns
